import { useCallback, useEffect, useState } from 'react'
import { TripsApi } from '@/shared/api/trips'
import type { PendingTripInviteItem } from '@/shared/api/trips'
import { useAuth } from '@/modules/auth'

export function usePendingTripInvites() {
  const { getAccessToken } = useAuth()
  const [invites, setInvites] = useState<PendingTripInviteItem[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchInvites = useCallback(async () => {
    const api = new TripsApi(getAccessToken)
    setError(null)
    setIsLoading(true)
    try {
      const data = await api.getMyPendingInvites()
      setInvites(data ?? [])
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load invitations')
      setInvites([])
    } finally {
      setIsLoading(false)
    }
  }, [getAccessToken])

  useEffect(() => {
    fetchInvites()
  }, [fetchInvites])

  return { invites, isLoading, error, refetch: fetchInvites }
}
